export const KINDS = [["ind", "IND"], ["sib", "SIB"], ["grad", "GRAD"]];
export const INK_HEX = {
  black: "#e2e8f0", blue: "#3b82f6", red: "#ef4444", green: "#22c55e",
  purple: "#a855f7", pink: "#ec4899", orange: "#f97316", pencil: "#94a3b8",
};
const toNums = (s) => (String(s).match(/\d+/g) || []).map(Number);

// One column per (kind, ink) — ink "" is the plain column used when a sheet has a single colour.
export function columnsFor(numbers) {
  const cols = [];
  KINDS.forEach(([k, label]) => {
    const inks = new Set();
    numbers.forEach((n) => (n[k] || []).forEach((v) => inks.add((n.ink_of || {})[String(v)] || "")));
    const list = [...inks].sort();
    (list.length ? list : [""]).forEach((ink) => cols.push({ k, ink, label, id: `${k}|${ink}` }));
  });
  // Number columns with no header on the sheet — the operator picks Sibling or Graduation.
  const xinks = {};
  numbers.forEach((n) => Object.entries(n.xcols || {}).forEach(([col, vals]) => vals.forEach((v) => {
    (xinks[col] = xinks[col] || new Set()).add((n.ink_of || {})[String(v)] || "");
  })));
  Object.keys(xinks).sort((a, b) => a - b).forEach((col) => [...xinks[col]].sort().forEach((ink) => {
    cols.push({ k: "x", col, ink, label: `Col ${col}`, id: `x${col}|${ink}` });
  }));
  return cols;
}

export function rowFromNumbers(n, cols) {
  const row = { idx: n.idx, confidence: n.confidence, page: n.page, order: n.order, cells: {} };
  cols.forEach((c) => { row.cells[c.id] = ""; });
  KINDS.forEach(([k]) => {
    (n[k] || []).forEach((v) => {
      const id = `${k}|${(n.ink_of || {})[String(v)] || ""}`;
      const target = id in row.cells ? id : cols.find((c) => c.k === k)?.id;
      row.cells[target] = row.cells[target] ? `${row.cells[target]}, ${v}` : String(v);
    });
  });
  Object.entries(n.xcols || {}).forEach(([col, vals]) => vals.forEach((v) => {
    const id = `x${col}|${(n.ink_of || {})[String(v)] || ""}`;
    const target = id in row.cells ? id : cols.find((c) => c.k === "x" && c.col === col)?.id;
    if (target) row.cells[target] = row.cells[target] ? `${row.cells[target]}, ${v}` : String(v);
  }));
  return row;
}

export function payloadRow(row, cols) {
  const out = { idx: row.idx, confidence: row.confidence, ind: [], sib: [], grad: [], xcols: {}, ink_of: {} };
  cols.forEach((c) => {
    toNums(row.cells[c.id] || "").forEach((v) => {
      if (c.k === "x") (out.xcols[c.col] = out.xcols[c.col] || []).push(v);
      else out[c.k].push(v);
      if (c.ink) out.ink_of[String(v)] = c.ink;
    });
  });
  return out;
}
